import { Star } from "lucide-react";

/** Stjärnbetyg med partiell blå ifyllnad (t.ex. 4,5/5 fyller 4,5 stjärnor). */
export function StarRating({ rating, className = "h-3.5 w-3.5" }: { rating: number; className?: string }) {
  const pct = Math.max(0, Math.min(100, (rating / 5) * 100));
  return (
    <span className="relative inline-flex" aria-label={`${rating} av 5`}>
      <span className="flex text-border">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star key={i} className={`${className} fill-current`} strokeWidth={0} />
        ))}
      </span>
      <span
        className="pointer-events-none absolute inset-0 flex overflow-hidden text-primary"
        style={{ width: `${pct}%` }}
        aria-hidden
      >
        {Array.from({ length: 5 }).map((_, i) => (
          <Star key={i} className={`${className} shrink-0 fill-current`} strokeWidth={0} />
        ))}
      </span>
    </span>
  );
}
